import { useState, useCallback, useEffect } from 'react';

// DEPENDENCIES
import isEmpty from 'lodash/isEmpty';
import { useDispatch, useSelector } from 'react-redux';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// ACTIONS
import { lookupActions } from 'actions.js';

// HELPERS
import { apiFetch } from 'functions.js';

// If everGreen is true then fetch only once on mount and update the redux store
// If everGreen is false then try to get the lookup from the redux store before fetching
export default function useLookup({ lookup: lookupKey, everGreen }) {
  const lookups = useSelector(state => state.lookups);

  const [lookupData, setLookupData] = useState(!everGreen ? lookups[lookupKey] : []);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  const fetchLookup = useCallback(() => {
    const args = {
      endpoint: ENDPOINTS.lookup[lookupKey],
      onFetch: () => setLoading(true),
      onSuccess: data => {
        setLookupData(data);
        dispatch(lookupActions.load(lookupKey, data?.result || data));
      },
      onError: error => {
        setLookupData(new Error(error));
        dispatch(lookupActions.error(lookupKey));
      },
      onComplete: () => setLoading(false)
    };

    apiFetch(args);
  }, [dispatch, lookupKey]);

  useEffect(() => {
    if (!isEmpty(lookupData)) return;
    fetchLookup();
  }, [everGreen, fetchLookup, lookupData]);

  return {
    fetchLookup,
    lookup: lookupData,
    loading
  };
}
